<template>
    <span v-if="countryCode && showImage" :style="tile ? 'display:inline-block;line-height:0;' : ''">
        <img class="country-display" :style="imageStyle" :src="imagePath" @error="imageError()">
    </span>
</template>

<script>
import countriesJson from '@/assets/data/countries.json'

export default {
    props: [
        'countryCode',
        'size',
        'tile'
    ],
    data () {
        return {
            countries: countriesJson,
            showImage: true
        }
    },
    methods: {
        imageError () {
            this.showImage = false
        }
    },
    computed: {
        imageStyle () {
            const px = this.size ? this.size + 'px' : '16px';
            if (this.tile) return `width:${px};height:${px};object-fit:cover;vertical-align:middle;`;
            return `width:${px};vertical-align:middle;`;
        },
        imagePath () {
            return this.assets()+'/flags/' + (this.countryCode ? this.countryCode.toUpperCase() : 'US')+ '.png'
        }
    }
}
</script>

<style scoped>
    .country-display {
        vertical-align: middle;
    }
</style>
